/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_TOGGLE_SMALL': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8 9h2v2H8zm6 0h2v2h-2zm-6 5h2v2H8zm6 0h2v2h-2z"/><path pid="1" d="M21.5 0H0v24h21.5a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 21.5 0zM23 21.5a1.5 1.5 0 0 1-1.5 1.5H1V1h20.5A1.5 1.5 0 0 1 23 2.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_TOGGLE_SMALL.js